import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OkMessageDialogData } from '../../interfaces/dialogs.interface';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';

@Component({
  selector: 'app-ok-message',
  templateUrl: './ok-message.component.html',
  styleUrls: ['./ok-message.component.scss'],
})
export class OkMessageComponent {
  constructor(
    public dialogRef: MatDialogRef<OkMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OkMessageDialogData,
    private readonly navService: NavigationLibraryService
  ) {}

  AfterViewInit() {
    this.navService.focusContainer('button-modal-container', true);
  }

  onActionProceed(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
